const tracksValidationFR = {
    "trackName": {
        "required": "Le nom de la piste est requis",
        "length": "Le nom de la piste doit comporter plus de 1 et moins de 255 caractères",
        "regexp": "Le nom de la piste ne peut contenir que des lettres, des chiffres, des espaces et des underscores"
    },
    "mix_name": {
        "required": "Veuillez saisir le nom du mix",
        "regexp": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores"
    },
    "artistName": {
        "required": "Veuillez sélectionner un artiste"
    },
    "artistType": {
        "required": "Veuillez sélectionner le type d'artiste"
    },
    "atleastOneMainArtist": {
        "required": "Au moins un artiste doit être principal"
    },
    "duplicateArtists": {
        "required": "Il y a deux artistes ou plus avec le même nom."
    },
    "publisherName": {
        "required": "Veuillez sélectionner un éditeur"
    },
    "publisherAuthor": {
        "required": "Veuillez insérer le vrai prénom et nom de la personne."
    },
    "contributorName": {
        "required": "Veuillez sélectionner un contributeur"
    },
    "contributorRole": {
        "required": "Veuillez sélectionner le rôle du contributeur"
    },
    "atleastOneComposer": {
        "required": "Au moins un contributeur doit être compositeur"
    },
    "atleastOneLyricist": {
        "required": "Au moins un contributeur doit être parolier"
    },
    "copyright": {
        "required": "Le droit d'auteur est requis",
        "regexp": "Le droit d'auteur ne peut contenir que des lettres, des chiffres, des espaces et des underscores"
    },
    "copyrightYear": {
        "required": "L'année du droit d'auteur est requise",
        "regexp": "L'année du droit d'auteur doit être une année valide"
    },
    "ISRC": {
        "required": "Veuillez fournir l'ISRC ou marquer Générer l'ISRC",
        "regexp": "Veuillez insérer un code ISRC valide ou laisser vide"
    },
    "DA_ISRC": {
        "required": "Veuillez fournir l'ISRC Dolby Atmos ou marquer Générer l'ISRC",
        "regexp": "Veuillez insérer un code ISRC valide ou laisser vide"
    },
    "trackLanguage": {
        "required": "La langue de la piste est requise. Veuillez sélectionner la langue de votre nom de piste."
    },
    "trackVocals": {
        "required": "La langue vocale de la piste est requise. Veuillez sélectionner la langue de vos voix."
    },
    "trackGenre": {
        "required": "Veuillez sélectionner le genre de votre piste."
    },
    "trackSubGenre": {
        "required": "Veuillez sélectionner le sous-genre de votre piste"
    },
    "featuringArtistMissing": {
        "required": "La piste doit avoir l'artiste en vedette mentionné dans le titre correctement assigné à un rôle d'artiste en vedette. Veuillez corriger et soumettre à nouveau."
    }
};

export default tracksValidationFR;